import {lazyRegister} from '@/Core/lazyRegister';
import {
    ChangePasswordModel,
    DistributorFilterItem
} from "@/models";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class DistributorService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllDistributors(query?: {
        countryId?: number,
        number?: string
    }, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<DistributorFilterItem[]>('/api/Distributor/filter-option', query, cancelToken);
    };

    public GetDatacenterDistributor(number: string) {
        return this.baseApiFactory.getData<any>(`/api/Distributor/GetDatacenter/${number}`);
    };

    public GetDistributorDetails(id) {
        return this.baseApiFactory.get<any>(`/api/Distributor/GetDetails/${id}`);
    };

    public UpdateDistributor(value: object) {
        return this.baseApiFactory.put<boolean>(`/api/Distributor`, value);
    };

    public InsertDistributor(value: object) {
        return this.baseApiFactory.post<boolean>(`/api/Distributor`, value);
    };

    public GetDistributorDetailsByCountry(query) {
        return this.baseApiFactory.getData<any>(`/api/DistributorDetails`, query);
    };

    public UpdateDistributorDetails(value) {
        return this.baseApiFactory.put<boolean>(`/api/DistributorDetails`, value);
    };

    public UpdateDetailOneField(postData) {
        return this.baseApiFactory.put<any>(`/api/CMSFieldUpdate`, postData);
    };

    public UpdateDetailManyFields(postData) {
        return this.baseApiFactory.put<any>(`/api/CMSFieldUpdate/multi`, postData);
    };

    public UpdateDetailSocialLinks(postData) {
        return this.baseApiFactory.post<any>(`/api/DistributorDetails/UpdateSocialLinks`, postData);
    };

    public UpdateDistributorDetailsIpAddress(postData) {
        return this.baseApiFactory.post<any>(`/api/DistributorDetails/UpdateDistributorDetailsIpAddress`, postData)
            ;
    };

    public UpdateDistributorDetailsFtpInfo(postData) {
        return this.baseApiFactory.post<any>(`/api/DistributorDetails/UpdateDistributorDetailsFtpInfo`, postData)
            ;
    };

    public UpdateDetailTrackings(postData: {
        id: number,
        ownerShipTag: string,
    }) {
        return this.baseApiFactory.post<any>(`/api/DistributorDetails/UpdateTrackings`, postData);
    };

    public UpdatePaymentSettings(postData) {
        return this.baseApiFactory.post<any>(`/api/DistributorDetails/UpdatePaymentSettings`, postData);
    };

    public GetTrustedShopInfo(query: {
        countryId: number,
        langCode: string
    }) {
        return this.baseApiFactory.getData<any>('/api/TrustedShop', query);
    };

    public LoadLogoPrintInfo(query) {
        return this.baseApiFactory.get<any>(`/api/SystemSetting?${query}`);
    };

    public UpdateActiveTrustedShop(postData) {
        return this.baseApiFactory.post<any>(`/api/DistributorDetails/UpdateActiveTrustedShop`, postData)
            ;
    };

    public UpdatePrivacyPolicySettings(postData) {
        return this.baseApiFactory.post<any>(`/api/DistributorDetails/UpdatePrivacyPolicySettings`, postData)
            ;
    };

    public UpdatePrivacyPolicyDealerSettings(postData) {
        return this.baseApiFactory.post<any>(`/api/DistributorDetails/UpdatePrivacyPolicyDealerSettings`, postData)
            ;
    };

    public InsertTrustedShopInfo(value) {
        return this.baseApiFactory.post<any>(`/api/TrustedShop`, value);
    };

    public UpdateTrustedShopInfo(value) {
        return this.baseApiFactory.put<any>(`/api/TrustedShop`, value);
    };

    public SaveLogoPrintGuide(value) {
        return this.baseApiFactory.post<any>(`/api/SystemSetting`, value);
    };

    public ExportDealer(param) {
        this.baseApiFactory.download(`/api/Distributor/ExportDealer?${param}`, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: "EPartner_Dealers_" + new Date().toISOString().split('T')[0]
                .replaceAll('-', '') + ".xlsx"
        });
    };

    public SearchDistributorAddresses(query) {
        return this.baseApiFactory.getData<any[]>(`/api/DistributorAddresses`, query);
    };

    public UpdateDistributorAddress(value) {
        return this.baseApiFactory.put<any>(`/api/DistributorAddresses`, value);
    };

    public InsertDistributorAddress(value) {
        return this.baseApiFactory.post<any>(`/api/DistributorAddresses`, value);
    };

    public DeleteDistributorAddress(id) {
        return this.baseApiFactory.delete<boolean>(`/api/DistributorAddresses/` + id);
    };

    public UpdateOverallPickupAddressStatus(value) {
        return this.baseApiFactory.put<any>(`/v2/api/Distributor/update-pickup-address-status`, value);
    }

    public UpdatePickupAddressStatus(value) {
        return this.baseApiFactory.put<any>(`/v2/api/DistributorAddress/update-pickup-address-status`, value);
    }

    public ExportEmail(value) {
        this.baseApiFactory.download(`/api/Distributor/ExportTermEmail?${value}`, {
            type: 'application/pdf',
            fileName: "TermsAndConditions.pdf"
        });
    };

    public UpdateOneFieldDistributor(postData) {
        return this.baseApiFactory.post<any>(`/api/Distributor/UpdateOneFieldDistributor`, postData);
    };

    getLogoByNumber(number: string, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<string>(`/v2/api/Distributor/get-logo-by-number/${number}`, null, cancelToken);
    }

    listByOrderStatistic(cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<DistributorFilterItem[]>('/v2/api/Distributor/list-by-order-statistic', null, cancelToken);
    }
}

lazyRegister.service('DistributorService', DistributorService);
